export default {
  No: 'no',
  Yes: 'yes',
}
